import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import { Redirect } from 'react-router-dom';
import { ToastContainer,toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';

const TrainingViewStatus = () => {

  const { trainingId} = useParams();

  const [list,setList] = useState([]);

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  useEffect(()=>{
    fetchStatus();
},[]);

const fetchStatus = async () => {
    try{
       const res = await axios.get(
      `${API_BASE_URL}/training-status/${trainingId}`,
      {
        headers:{
          Authorization:`Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

        setList(res.data.data);

    }catch(error){
        console.error(error);
    }
};

const renderStatus = (value) => {
    return value === 1
    ? <span style={{color:"green",fontWeight:"bold"}}>Completed</span>
    : <span style={{color:"red",fontWeight:"bold"}}>Not Completed</span>
};


   return (
     <>
       <ToastContainer />

<div className="container-fluid">

<div className="card">

<div className="card-header">
<h4>View Status List</h4>
</div>

<div className="card-body">

<table className="table table-bordered">
<thead>
<tr>
<th>Employee</th>
<th>Course</th>
<th>Topic</th>
<th>Pre Test</th>
<th>Training View</th>
<th>Post Test</th>
</tr>
</thead>

<tbody>

{list.map((item,index)=>(
<tr key={index}>
<td>{item.first_name} {item.last_name} ({item.participate_mem})</td>
<td>{item.course_name}</td>
<td>{item.topic_name}</td>
<td>{renderStatus(item.pre_test_status)}</td>
<td>{renderStatus(item.training_view_status)}</td>
<td>{renderStatus(item.post_test_status)}</td>
</tr>
))}

</tbody>

</table>


</div>

</div>

</div>

   </>
  );

}

export default TrainingViewStatus;